import axios from '@/libs/http'

export const getLocation = () => {
  return axios.request({
    url: '/s/c/clerk/getLocation',
    method: 'get',
  })
}

export const updateLocation = (id,address,detailAddress,lat,lng) => {
  let data = new URLSearchParams()
  if(id){
    data.append("id",id)
  }
  data.append("address",address)
  data.append("detailAddress",detailAddress)
  data.append("lat",lat)
  data.append("lng",lng)

  return axios.request({
    url: '/s/c/clerk/updateLocation',
    data,
    method: 'post',
  })
}
